import config from 'config';

import { Box, useBreakpointValue } from '@chakra-ui/react';

import { Link } from 'ui';

const { iconLogo: IconLogo, logoLink, isExternalLink, isSquareIcon } = config;

const Logo = () => {
  const logoHeight = useBreakpointValue({ base: '46px', md: '75px' });
  const logoWidth = useBreakpointValue({ base: '300px', sm: 'auto' });
  return (
    <Link to={logoLink} external={isExternalLink}>
      <Box>
        {isSquareIcon ? (
          <IconLogo
            style={{
              height: logoHeight,
              width: logoWidth
            }}
          />
        ) : (
          <IconLogo style={{ maxHeight: logoHeight, maxWidth: logoWidth }} />
        )}
      </Box>
    </Link>
  );
};

export default Logo;
